import { useQuery } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useQualificationScorecard = (enabled = true) => {
  const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  return useQuery({
    queryKey: ['qualificationScorecard'],
    queryFn: async () => {
      const url = `${prefix}/qualification-scorecards`;
      const result = await restClient({ url });
      return result;
    },
    enabled,
    staleTime: 0,
    cacheTime: 0
  });
};
